export const AmplitudeEvents = {
  // main links clicked
  HOME_APP_CLICKED: 'home_app_clicked',
  CATEGORIES_CLICKED: 'categories_clicked',
  CART_CLICKED: 'cart_clicked',
  MY_ACCOUNT_CLICKED: 'my_account_clicked',
  SEARCH_BAR_CLICKED: 'search_bar_clicked',
  STORES_CLICKED: 'stores_clicked',
  JOIN_US: 'join_us',
  MY_WISHLIST_CLICKED: 'my_wishlist_clicked',

  // Account Screen
  EDIT_ACCOUNT_CLICKED: 'Edit Account Clicked',
  MY_ORDERS_CLICKED: 'My Orders Clicked',
  FAVORITES_CLICKED: 'Favorites Clicked',
  WALLET_CLICKED: 'Wallet Clicked',
  MY_ADDRESSES_CLICKED: 'My Addresses Clicked',
  MY_SAVED_CARDS_CLICKED: 'My Saved Cards Clicked',
  CHANGE_LANGUAGE_CLICKED: 'Change Language Clicked',
  ABOUT_PIK_CLICKED: 'About Pik Clicked',
  CONTACT_US_CLICKED: 'Contact Us Clicked',
  SETTINGS_CLICKED: 'Settings Clicked',
  CHOOSE_LANGUAGE_CLICKED: 'Choose Language Clicked',
  PRIVACY_POLICY_CLICKED: 'Privacy Policy Clicked',
  TERMS_AND_CONDITIONS_CLICKED: 'Terms and Conditions Clicked',
  PRIME_CLICKED: 'Prime Clicked',

  // single pages
  STORE_CLICKED: 'store_clicked',

  // Store Screen
  STORE_ADDED_TO_FAVORITE: 'store_added_to_favorite',
  Store_Removed_From_Favorite: 'store_removed_from_favorite',
  Filter_Clicked: 'filter_clicked',
  Store_Industry_Clicked: 'store_industry_clicked',
  Store_SubIndustry_Clicked: 'store_subIndustry_clicked',
  Store_More_Info_Clicked: 'store_more_info_clicked',

  // product screen
  PRODUCT_CLICKED: 'product_clicked',
  PRODUCT_ADDED_TO_FAVORITE: 'product_added_to_favorite',
  PRODUCT_REMOVED_FROM_FAVORITE: 'product_removed_from_favorite',
  CART_ICON_CLICKED: 'cart_icon_clicked',
  PRODUCT_ADDED_TO_CART: 'product_added_to_cart',
  PRODUCT_REMOVED_FROM_CART: 'product_removed_from_cart',
  PRODUCT_QUANTITY_INCREASED: 'product_quantity_Increased',
  PRODUCT_QUANTITY_DECREASED: 'product_quantity_Decreased',
  PRODUCT_PICTURE_CLICKED: 'product_picture_clicked',

  // Checkout Screen - Deliver Now Order
  Order_Type_Clicked: 'order_type_clicked',
  Change_Payment_Method: 'change_payment_method',
  Use_Wallet_Balance_Clicked: 'use wallet balance clicked',
  Apply_Coupon_Code_Clicked: 'apply_coupon_code_clicked',
} as const;

export type AmplitudeEventProperties = {
  // main links clicked
  [AmplitudeEvents.CART_CLICKED]: {
    // Optional: Add properties if needed
    userId?: string;
  };
  [AmplitudeEvents.MY_ACCOUNT_CLICKED]: {
    // Optional: Add properties if needed
    userId?: string;
  };
  [AmplitudeEvents.SEARCH_BAR_CLICKED]: {
    // Optional: Add properties if needed
    userId?: string;
  };

  [AmplitudeEvents.MY_WISHLIST_CLICKED]: {
    // Optional: Add properties if needed
    userId?: string;
  };
  [AmplitudeEvents.HOME_APP_CLICKED]: {
    // Optional: Add properties if needed
    userId?: string;
  };
  [AmplitudeEvents.CATEGORIES_CLICKED]: {
    // Optional: Add properties if needed
    userId?: string;
  };
  [AmplitudeEvents.EDIT_ACCOUNT_CLICKED]: {
    // Optional: Add properties if needed
    userId?: string;
  };
  [AmplitudeEvents.MY_ORDERS_CLICKED]: {
    // Optional: Add properties if needed
    userId?: string;
  };
  [AmplitudeEvents.FAVORITES_CLICKED]: {
    // Optional: Add properties if needed
    userId?: string;
  };
  [AmplitudeEvents.WALLET_CLICKED]: {
    // Optional: Add properties if needed
    userId?: string;
  };

  [AmplitudeEvents.MY_ADDRESSES_CLICKED]: {
    // Optional: Add properties if needed
    userId?: string;
  };
  [AmplitudeEvents.MY_SAVED_CARDS_CLICKED]: {
    // Optional: Add properties if needed
    userId?: string;
  };
  [AmplitudeEvents.CHANGE_LANGUAGE_CLICKED]: {
    // Optional: Add properties if needed
    userId?: string;
  };
  [AmplitudeEvents.ABOUT_PIK_CLICKED]: {
    // Optional: Add properties if needed
    userId?: string;
  };
  [AmplitudeEvents.CONTACT_US_CLICKED]: {
    // Optional: Add properties if needed
    userId?: string;
  };
  [AmplitudeEvents.SETTINGS_CLICKED]: {
    // Optional: Add properties if needed
    userId?: string;
  };
  [AmplitudeEvents.CHOOSE_LANGUAGE_CLICKED]: {
    // Optional: Add properties if needed
    userId?: string;
  };
  [AmplitudeEvents.PRIVACY_POLICY_CLICKED]: {
    // Optional: Add properties if needed
    userId?: string;
  };
  [AmplitudeEvents.TERMS_AND_CONDITIONS_CLICKED]: {
    // Optional: Add properties if needed
    userId?: string;
  };
  [AmplitudeEvents.PRIME_CLICKED]: {
    // Optional: Add properties if needed
    userId?: string;
  };
  [AmplitudeEvents.JOIN_US]: {
    // Optional: Add properties if needed
    userId?: string;
  };
  [AmplitudeEvents.STORES_CLICKED]: {
    userId?: string;
  };

  [AmplitudeEvents.STORE_CLICKED]: {
    storeID: number; // Store ID
    storeName: string; // Store Name
    branchID: number;
    branchName: string;
  };

  // Store Screen
  [AmplitudeEvents.STORE_ADDED_TO_FAVORITE]: {
    storeID: number; // Store ID
    storeName: string; // Store Name
    branchID: number;
    branchName: string;
  };

  [AmplitudeEvents.Store_Removed_From_Favorite]: {
    storeID: number; // Store ID
    storeName: string; // Store Name
    branchID: number;
    branchName: string;
  };

  [AmplitudeEvents.Filter_Clicked]: {
    storeID: number; // Store ID
    storeName: string; // Store Name
    branchID: number;
    branchName: string;
  };

  [AmplitudeEvents.Store_Industry_Clicked]: {
    storeID: number; // Store ID
    storeName: string; // Store Name
    branchID: number;
    branchName: string;
    industryID: number;
    industryName: string;
  };
  [AmplitudeEvents.Store_SubIndustry_Clicked]: {
    storeID: number; // Store ID
    storeName: string; // Store Name
    branchID: number;
    branchName: string;
    subIndustryID: number;
    subIndustryName: string;
  };

  [AmplitudeEvents.Store_More_Info_Clicked]: {
    storeID: number; // Store ID
    storeName: string; // Store Name
    branchID: number;
    branchName: string;
  };

  // product screen
  [AmplitudeEvents.PRODUCT_CLICKED]: {
    storeId: number;
    storeName: string;
    branchId: number | string;
    productId: string;
    productName: string | null;
  };

  [AmplitudeEvents.PRODUCT_ADDED_TO_FAVORITE]: {
    storeId: number;
    storeName: string;
    branchId: number;
    productId: string;
    productName: string;
  };
  [AmplitudeEvents.PRODUCT_REMOVED_FROM_FAVORITE]: {
    storeId: number;
    storeName: string;
    branchId: number;
    productId: string;
    productName: string;
  };
  [AmplitudeEvents.CART_ICON_CLICKED]: {
    userId?: string;
  };
  [AmplitudeEvents.PRODUCT_ADDED_TO_CART]: {
    storeId: number;
    storeName: string;
    branchId: number;
    productId: string;
    productName: string;
    productPrice: number;
    productQuantity: number;
  };
  [AmplitudeEvents.PRODUCT_REMOVED_FROM_CART]: {
    storeId: number;
    storeName: string;
    branchId: string;
    productId: string;
    itemTypeId: number;
    variantId?: string;
    productName: string;
    productPrice: number;
    productQuantity?: number;
  };
  [AmplitudeEvents.PRODUCT_QUANTITY_INCREASED]: {
    storeId: number;
    storeName: string;
    branchId: string;
    productId: string;
    itemTypeId: number;
    variantId?: string;
    productName: string;
    productPrice: number;
    productQuantity?: number;
  };
  [AmplitudeEvents.PRODUCT_QUANTITY_DECREASED]: {
    storeId: number;
    storeName: string;
    branchId: string;
    productId: string;
    itemTypeId: number;
    variantId?: string;
    productName: string;
    productPrice: number;
    productQuantity?: number;
  };
  [AmplitudeEvents.PRODUCT_PICTURE_CLICKED]: {
    storeId: number;
    storeName: string;
    branchId: number;
    productId: string;
    productName: string;
  };

  [AmplitudeEvents.Order_Type_Clicked]: {
    orderType: string;
    storeID: number;
    storeName: string;
    branchID: number;
    branchName: string;
    cartId: number;
    cartStatus: string;
  };

  [AmplitudeEvents.Change_Payment_Method]: {
    paymentMethod: number;
  };

  [AmplitudeEvents.Use_Wallet_Balance_Clicked]: {
    balanceAmount: string;
    balanceUsed: 'yes' | 'no';
  };

  [AmplitudeEvents.Apply_Coupon_Code_Clicked]: {
    couponUsed: 'yes' | 'no';
    CouponCode: string;
  };
};
